import { PackageContentWeb } from "./web";
import { PackageContentBlockProps } from "./types";

export function PackageContentWebEditor(props: PackageContentBlockProps) {
  return <PackageContentWeb {...props} />;
}
